function SmoothScroll() {
	scrollController =
		new ScrollMagic.Controller(
			{
				refreshInterval: 0,
			}
		);
    /*
	if (noTouchEvent) {
		scrollBar = Scrollbar.init(
			document.querySelector("#scrollContainer"), {damping: 0.075}
		);

		scrollController.scrollPos(function () {
			return currentY;
		});

		scrollBar.addListener(function (status) {
			currentY = status.offset.y;
			scrollController.update(true);
		});

		const previousY = localStorage.getItem('currentScroll');
		if (devMode === 'true' && previousY) {
			setTimeout(function () {
				scrollBar.setPosition(0, previousY);
			}, 500);
		} else {
			setTimeout(function () {
				scrollBar.setPosition(0, 0);
				$(window).trigger('scrollBarRestoreDone');
			}, 200);
		}
	}
    */
	barbaCallbacks.push(this);
}

SmoothScroll.prototype.build = function () {
	if (scrollBar) {
		scrollBar.setPosition(0, 1);
		scrollBar.setPosition(0, 0);
		scrollBar.update();
	} else {
		window.scrollTo(0, 0);
	}
};
